/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Recommenedations for for you web
 */

import Listable from '../../shared/bizos/listable'

export const ListablesType = {
  recs: [],
  scores: [],
}

// eslint-disable-next-line import/no-default-export
export default {
  fromJS: (data) => {
    if (data) {
      const recs = { recs: [], scores: [] }
      if (data.recs) {
        recs.recs = data.recs.map((listable) =>
          Listable.fromJS({
            is_featured: false,
            ...listable,
          })
        )
      }
      if (data.scores) {
        recs.scores = data.scores
      }
      return recs
    }
    return ListablesType
  },
}
